<script setup>
import config from '@/common/config'
import { degToRad, get, loadEpsgs, loadEpsgsWithPrjInit, openWin, post, qsel, ymd } from '@/common/util'
import DraggableResizableVue from 'draggable-resizable-vue3'
import { Feature, Map, View } from 'ol'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import { Icon, Style } from 'ol/style'
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { reactive } from 'vue'
import { useRoute } from 'vue-router'
import {defaults as defaultControls} from 'ol/control/defaults.js'
import { fromLonLat, Projection } from 'ol/proj'
import { Point } from 'ol/geom'
import { useMemberStore, useMetaStore } from '@/stores'
import { register } from 'ol/proj/proj4'
import proj4 from 'proj4';
import _ from 'lodash-es'
import BgMapSelector from '@/components/BgMapSelector.vue'
import LayerGroup from 'ol/layer/Group'
import { bboxPolygon,point,booleanPointInPolygon } from '@turf/turf'
/*
http://localhost:3000/ui/member/svnew/689d95c5c9f50b05159edbee/28d0fbf74f854b628205c00ffb7da984/69292a19e58fb5377fde02c4
*/
const initmapheight=360,route=useRoute(),meta=reactive({isResizing:false,leftbtnsize:42,subdivtype:null,mapzoom:18,extbasepattern:/((?:\d+\/)+)(\d+)(?:[^\/\.]+)?\.(png|jpg|jpeg|gif|webp|bmp)$/i})
  ,svifr=ref(null),memStore=useMemberStore(),metaStore=useMetaStore()
  ,leftmenus=ref([
      {
        "icon": "mdi-map-outline",
        "key": "map",
        "txt": "지도보기"
      },
      {
        "icon": "mdi-list-box-outline",
        "key": "memolist",
        "txt": "메모목록"
      },
      {
        "icon": "mdi-pen",
        "key": "memoadd",
        "txt": "메모작성"
      },
      {
        "icon": "mdi-rotate-3d",
        "key": "3d",
        "txt": "3D보기"
      },
      {
        "icon": "mdi-eye-circle-outline",
        "key": "objdetect",
        "txt": "객체탐지(AI)"
      },
      {
        "icon": "mdi-map-marker-radius-outline",
        "key": "legend",
        "txt": "범례보기"
      }
    ]
  )
const dragprop = ref({
  x: 50,
  y: 0,
  w: 400,
  h: initmapheight,
  maxw:window.innerWidth*0.9,
  maxh:window.innerHeight*0.9,
  isActive: true,
  draggable: false,
  handles:['tr'],
  handlesType:'custom',
  classNameHandle:'draghandle'
}),wfsGet=async({fids,layernm,filter})=>{
  const wfsParams = {SERVICE:'WFS',VERSION:'1.0.0',REQUEST:'GetFeature',TYPENAME:layernm,OUTPUTFORMAT:'application/json'}
  if(filter)wfsParams.FILTER=filter
  else if(fids?.length)wfsParams.FEATUREID=fids.toString()
  const wres=await get('wfs',()=>{},wfsParams)
  return wres
},wfsPost=async({ fids, layernm, filter })=>{
  const url = config.backend + 'wfs';
  let filterXml = '';
  if (filter) {
      filterXml = filter;
  } else if (fids?.length) {
      filterXml = `<ogc:Filter><ogc:FeatureId fid="${fids.join(',')}"/></ogc:Filter>`;
  }
  const postBody = `<wfs:GetFeature service="WFS" version="1.0.0"
          outputFormat="application/json"
          xmlns:wfs="http://www.opengis.net/wfs"
          xmlns:ogc="http://www.opengis.net/ogc"
          xmlns:gml="http://www.opengis.net/gml">
          <wfs:Query typeName="${layernm}">
              ${filterXml}
          </wfs:Query>
      </wfs:GetFeature>`;

  try {
      const response = await fetch(url, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/xml',
          },
          body: postBody
      });
      if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
  } catch (e) {
      console.error("WFS 호출 중 오류 발생:", e);
      return null;
  }
},submapFeatureAngle=rad=>{
  if(!meta.markerlayer||!meta.markerfeature)return
  const style= meta.markerlayer.getStyle().clone()
  style.getImage().setRotation(rad)
  meta.markerlayer.setStyle(style)
},ifrMsgHandler=async evt=>{
  const type=evt.data.type;
  if(type=='featurechanged'){
    awareIfr({type:'meminfo',mid:memStore.mid,bearertoken:memStore.bearertoken},'*')
    meta.currentfid=evt.data.fid
		window.history.pushState(null, '', location.href.split('svnew/')[0]+`svnew/${meta.svid}/${meta.currentfid}/${meta.bgmapid}`)
    if(!meta.sv){
      meta.sv=await get('rest/public/sv?svid='+meta.svid,res=>meta.sv=res.data)
      meta.sv=meta.sv.data
    }
    let filter='<Filter><PropertyIsEqualTo><PropertyName>featureid</PropertyName><Literal>'+meta.currentfid+'</Literal></PropertyIsEqualTo></Filter>'
    let feature=await wfsGet({layernm:meta.sv.gspointnm,filter})
    feature=feature.features[0]
    meta.feature={id:feature.id,...feature.properties}
    meta.baserad=degToRad(meta.feature.hangle)
    submapFeatureAngle(degToRad(meta.feature.hangle+evt.data.hlookat))
    let pos=fromLonLat([meta.feature.xpos,meta.feature.ypos])
    if(meta.markerfeature){
      meta.markerfeature.getGeometry().setCoordinates(pos)
      meta.submap.getView().setCenter(pos)
    }
    const pms={path:'req/address',service:'address',request:'getAddress',version:'2.0',crs:'EPSG:3857',type:'both',zipcode:'true',simple:'false',key: meta.vwapikey,point: pos}
    const turfpt = point([meta.feature.xpos,meta.feature.ypos]);
    const turfpoly = bboxPolygon([
      config.KoreaBbox.lonMin,
      config.KoreaBbox.latMin,
      config.KoreaBbox.lonMax,
      config.KoreaBbox.latMax
    ]);
    if(booleanPointInPolygon(turfpt, turfpoly)){
      try{
        const res=await vwapi('get',pms)
        if(res.response.result&&res.response.result.length>0){
          meta.addr=res.response.result[0].text
          meta.zipcode=res.response.result[0].zipcode
          meta.addrtype=res.response.result[0].type
          awareIfr({type:'featureaddr',fid:meta.currentfid,addr:meta.addr,zipcode:meta.zipcode,addrtype:meta.addrtype})
        }
      }catch(e){
        console.log('vwapi error',e)
        metas('주소를 검색할 수 없습니다.')
      }
    }
    if(meta.subdivtype=='memolist'||meta.subdivtype=='memoadd')searchMemo()
    if(!meta.featurelinks)meta.featurelinks={}
    const featurelink=await get('rest/authed/member/featurelink/streetview/'+meta.currentfid)
    if(featurelink.data.id){
      meta.featurelinks[featurelink.data.featureid]=featurelink.data.url
    }
  }
  if(type=='hlookatchanged'){
    if(meta.subdivtype=='map'){
      if(meta.markerfeature){
        let ang=evt.data.hlookat
        ang=degToRad(ang)
        ang+=meta.baserad
        submapFeatureAngle(ang)
      }
    }
  }
  if(type=='memoaddclick'){
    const ath=evt.data.ath
    const atv=evt.data.atv
    console.log(ath,atv)
  }
  if(type=='memosaved')searchMemo()
  if(type=='memodeleted')searchMemo()
},searchMemo=async(page=1)=>{
  const memolistwrap=qsel('.memolist')
  let size=5,wrapheight=memolistwrap.offsetHeight
  if(wrapheight){
    const ttlheight=qsel(memolistwrap,'.v-card-title').offsetHeight
    const actheight=qsel(memolistwrap,'.v-card-actions').offsetHeight
    size=Math.floor(wrapheight/36)-6
    if(size<5)size=5
  }
  const pm={where:{ttl_or_:meta.memosearchval,cont_or_:meta.memosearchval,featureid_eq_:meta.currentfid},page:page,size:size,sortcol:'mdt',isasc:false}
  pm.where.cont_or_=pm.where.ttl_or_
  const res=await post('rest/authed/member/searchmemo',pm)
  meta.memos=res.data
  awareIfr({type:'dispmemos',memos:JSON.stringify(meta.memos.rows)},'*')
},awareIfr=data=>{
  svifr.value.contentWindow.postMessage(data,'*')
},selSub=type=>{
  let enablememoadd=false
  if(type=='objdetect'||type=='legend')return metaStore.toast('준비중 입니다.')
  if(type=='3d'){
    const featurelink=meta.featurelinks[meta.currentfid]
    if(!featurelink)metaStore.toast('준비중입니다.')
    else openWin(featurelink)
    return
  }
  if(meta.subdivtype==type){
    type=null
  }else{
    if(type=='memoadd')enablememoadd=true
    if(type=='memolist'||type=='memoadd')searchMemo()
  }
  meta.subdivtype=type
  awareIfr({type:'enablememoadd',value:enablememoadd},'*')
  if(!type){
    return
  }
  if(type=='map')initSubMap()
},initSubMap=()=>{
  if(meta.submap||!meta.feature)return
  let pos=fromLonLat([meta.feature.xpos,meta.feature.ypos])
  const basemapgroup=new LayerGroup()
  basemapgroup.set('nm','basemapgroup')
  const markerlayer=new VectorLayer({source:new VectorSource(),style:new Style({image: new Icon({anchorOrigin:'center-center',src:`${config.frontRoot}arrow-north.png`,rotation:meta.baserad})})})
  // const markerlayer=new VectorLayer({source:new VectorSource(),style:new Style({image: new Icon({anchorOrigin:'center-center',src:`${config.frontRoot}arrow-north.png`,rotation:meta.initang})})})
  meta.submap=new Map({target:'submap',layers:[basemapgroup,markerlayer],controls:defaultControls(),view:new View({zoom:meta.mapzoom,center:pos})})
  meta.markerlayer=markerlayer
  const mf=new Feature({geometry:new Point(pos)})
  meta.markerlayer.getSource().addFeature(mf)
  meta.markerfeature=mf
},vwapi=async(method='get',data,callback=()=>{})=>{
  const url='rest/authed/member/vwapi'
  if (data instanceof Function){
    callback=data
    data=null
  }
  if(method=='get')return await get(url,callback,data)
  return await post(url,data,callback)
}
const updateWindowSize = () => {
  window.dragprop = dragprop.value
  dragprop.value.maxw=screen.availWidth*0.8
  dragprop.value.maxh=screen.availHeight*0.8
  dragprop.value.w=400
  dragprop.value.h=initmapheight
  dragprop.value.x=50
  dragprop.value.y=0
};
onMounted(()=>{
  window.addEventListener('resize', updateWindowSize)
  meta.svid=route.params.svid
  meta.initfid=route.params.fid
  meta.bgmapid=route.params.bgmapid
  get('rest/authed/member/confs/vwapikey',async res=>{
    meta.vwapikey=res.data[0].sval
  })
  loadEpsgsWithPrjInit(async epsgs=>meta.epsgs=epsgs)
  window.addEventListener('message',ifrMsgHandler)
})
onBeforeUnmount(()=>{
  window.removeEventListener('message',ifrMsgHandler)
  window.removeEventListener('resize', updateWindowSize)
})
</script>
<template>
  <div class="svnewwrap">
    <v-card flat class="ifrwrap">
      <iframe v-if="meta.svid&&meta.initfid" ref="svifr" name="svifr" title="svifr" :src="`${config.backend}svcore?svid=${meta.svid}&fid=${meta.initfid}`"></iframe>
      <!-- <iframe ref="svifr" name="svifr" title="svifr" :src="`http://127.0.0.1:5500/svcore.html?svid=${meta.svid}&fid=${meta.initfid}`"></iframe> -->
      <v-overlay v-model="meta.blockifr" class="align-center justify-center" contained/>
    </v-card>
    <div class="leftwrap">
      <div class="leftbtnwrap">
        <v-btn v-for="(menu,idx) in leftmenus" :key="menu.key" :icon="menu.icon" :size="meta.leftbtnsize" :color="meta.subdivtype==menu.key?'primary':'default'"
          @click="selSub(menu.key)"
          @mouseenter.stop.prevent="evt=>{
            meta.tooltiptxt=menu.txt;
            meta.tooltiptop=evt.target.offsetTop+8;
          }" @mouseleave="meta.tooltiptxt=null"/>
      </div>
      <DraggableResizableVue v-show="meta.subdivtype" :max-width="dragprop.maxw" :max-height="dragprop.maxh"
        :prevent-deactivation="true"
        v-model:draggable="dragprop.draggable"
        v-model:handles="dragprop.handles"
        v-model:classNameHandle="dragprop.classNameHandle"
        v-model:x="dragprop.x"
        v-model:y="dragprop.y"
        v-model:w="dragprop.w"
        v-model:h="dragprop.h"
        v-model:active="dragprop.isActive"
        @resizing="()=>{if(!meta.blockifr)meta.blockifr=true;}"
        @resizestop="()=>{
          meta.blockifr=false;
          searchMemo();
        }">
        <BgMapSelector v-if="meta.submap" :map="meta.submap" :initid="meta.bgmapid" hidden/>
        <div v-show="meta.subdivtype=='map'" id="submap"></div>
        <v-card v-show="meta.subdivtype=='memoadd'||meta.subdivtype=='memolist'" height="100%" class="overflow-y-auto memolist">
          <v-card-title>
            <h4>메모 목록</h4>
            <v-row>
              <v-col cols="8"><v-text-field hide-details clearable variant="outlined" density="compact" :label="$t('enteryoursearchterm')" v-model="meta.memosearchval"/></v-col>
              <v-col><v-btn prepend-icon="mdi-magnify" color="secondary" :text="$t('search')" @click="searchMemo(1)"/></v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-table fixed-header density="compact" class="border-thin mt-2" height="100%">
              <thead>
                <tr>
                  <th>{{ $t('registrationmodificationdate') }}</th>
                  <th>{{ $t('title') }}</th>
                  <th v-if="meta.subdivtype!='memoadd'" class="text-center">{{ $t('more') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!meta.memos||!meta.memos.rows||!meta.memos.rows.length"><td colspan="3" class="text-center">{{ $t('noresultsfound') }}</td></tr>
                <tr v-else v-for="memo in meta.memos.rows">
                  <td>{{ ymd(memo.mdt) }}</td>
                  <td>{{ memo.ttl }}</td>
                  <td v-if="meta.subdivtype!='memoadd'" class="text-center"><v-btn density="compact" :text="$t('more')" @click="awareIfr({type:'popmemo',memoid:memo.id,ath:memo.ath,atv:memo.atv})"/></td>
                </tr>
              </tbody>
            </v-table>
          </v-card-text>
          <v-card-actions>
            <v-pagination v-if="meta.memos" density="compact" class="ma-auto" :length="meta.memos.totalPages" :total-visible="5" :model-value="meta.memos.currentPage" @update:model-value="searchMemo"/>
          </v-card-actions>
        </v-card>
      </DraggableResizableVue>
      <div v-if="meta.tooltiptxt" :style="{position:'absolute',backgroundColor:'#fff',left:'52px',top:meta.tooltiptop+'px',whiteSpace:'nowrap',minWidth:'20px',maxWidth:'100px',fontWeight:'bold',fontSize:'14px',padding:'2px'}">
        {{ meta.tooltiptxt }}
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.svnewwrap{
  position: relative;
  width: 100%;
  height: 100%;
  .ifrwrap{
    position: absolute;
    display: block;
    margin: 0;
    padding: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-width: 0;
    iframe{
      width: 100%;
      height: 100%;
      border-width: 0;
    }
  }
  .leftwrap{
    position: absolute;
    left: 5px;
    bottom: 5%;
    display: flex;
    gap:20px;
    .leftbtnwrap{
      display: flex;
      flex-direction: column;
      gap: 18px;
    }
    .draghandle{
      background-color: white;
      margin: 30px;
      width: 30px;
      height: 30px;
      background-image: url('/resize_tr.png');
      background-size: contain;
      z-index: 1;
    }
  }
  #submap{
    width: 100%;
    height: 100%;
  }
}
</style>


